import { render, staticRenderFns } from "./registerBanner.vue?vue&type=template&id=05cd9d3f&scoped=true&"
import script from "./registerBanner.vue?vue&type=script&lang=js&"
export * from "./registerBanner.vue?vue&type=script&lang=js&"
import style0 from "./registerBanner.vue?vue&type=style&index=0&id=05cd9d3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cd9d3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
